/* 处理tag(问题分类)的数据 */

const normalizer = (node) => {
    return {
        label: node.name,
        id: node.id,
        children: node.child
    }
}

const labelName = (node) => {
    return node.nestedSearchLabel ? node.nestedSearchLabel.replace(/\s/g, '/') : ''
}

const clearEmptyChild = (arr) => {
    if (!arr) return [] 

    arr.forEach(item => {
        if(item.child) {
            if(item.child && !item.child.length) {
                delete item.child
            }else{
                clearEmptyChild(item.child)
            }
        }
    })
    return arr
}

/**
 * @description 问题分类回显(根据tagId)
 * @param {Object} o
 * @param {Array} tagsList 问题分类字典
 * @return {String} 
 */
const tagsName = ({ tag }, tagsList) => {
    if (!tagsList || !tagsList.length) return '--'
    if (!tag) return '--'

    let names = []
    findName(tag, tagsList, names)

    function findName (tag, list, names) {
        let obj = list.find(x => x.id === tag)
        if (obj) {
            names.push(obj.name)
            obj.pid && findName(obj.pid, tagsList, names)
        }
        else {
            list.forEach(o => { o.child && findName(tag, o.child, names) })
        }
    }
    
    return names.reverse().join('/')
}


export default {
    normalizer,
    labelName,
    clearEmptyChild,
    tagsName
}
